import { SimpleButton } from '@apia/components';
import { CollectorField } from '../CollectorField';
import { ButtonProps } from '@apia/theme';
import { getLabelName, TLabel } from '@apia/util';

let i = 0;

export class CollectorButton extends CollectorField<
  null,
  Omit<ButtonProps, 'children'>
> {
  type = 'button';

  constructor(
    protected label: string | TLabel,
    properties?: Omit<ButtonProps, 'children'>,
  ) {
    super(`Button${i++}`, label, properties);
  }

  Component = () => {
    const props = this.useProperties();

    return <SimpleButton {...props}>{getLabelName(this.label)}</SimpleButton>;
  };
}
